angular
	.module 'App.Repository'

.factory 'CompanyRepository', ['BaseRepository', (BaseRepository) ->
	class CompanyRepository extends BaseRepository
		@resource = '/companies'
		@isRestricted = true
	return new CompanyRepository
]
